module.exports = __webpack_public_path__ + "static/media/Broker.6b667e9a.jpg";